import url from './url';



export default url(({ requestId = ':requestId' }) => `/config-visualize/${requestId}/details`);
